
type ClassValue =
    | string
    | number
    | bigint
    | false
    | null
    | undefined;

export const cx = (...classes: ClassValue[]) =>
    classes
        .filter(
            (c): c is string =>
                typeof c === 'string' && c.trim().length > 0
        )
        .join(' ');
